import {
  AggregateField,
  AggregateSpec,
  average,
  CollectionReference,
  count,
  DocumentData,
  getAggregateFromServer,
  Query,
  sum,
} from './adaptor';

export class FirestoreAggregate {
  static async get<T extends DocumentData, R extends AggregateSpec>(
    col: Query<T> | CollectionReference<T>,
    aggregate: R
  ): Promise<Record<keyof R, number>> {
    const snapshot = await getAggregateFromServer(col, aggregate);
    return snapshot.data() as Record<keyof R, number>;
  }

  static count(): AggregateField<number> {
    return count();
  }

  static sum(field: string): AggregateField<number> {
    return sum(field);
  }

  static average(field: string): AggregateField<number> {
    return average(field);
  }
}
